export var IDebugEnv;
(function (IDebugEnv) {
    IDebugEnv["DEV"] = "DEV";
    IDebugEnv["PRE_PROD"] = "PRE_PROD";
    IDebugEnv["PROD"] = "PROD";
})(IDebugEnv || (IDebugEnv = {}));
